import { createSlice } from '@reduxjs/toolkit';

import { MoviesState } from '../../types';

export const movieReducerInitialState: MoviesState = {
  nowPlayingMovies: {
    movieList: [],
    currentPage: 1,
    totalPages: 0,
    totalMovies: 0,
  },
  popularMovies: {
    movieList: [],
    currentPage: 1,
    totalPages: 0,
    totalMovies: 0,
  },
  topRatedMovies: {
    movieList: [],
    currentPage: 1,
    totalPages: 0,
    totalMovies: 0,
  },
  upcomingMovies: {
    movieList: [],
    currentPage: 1,
    totalPages: 0,
    totalMovies: 0,
  },
  searchMovies: {
    movieList: [],
    currentPage: 1,
    totalPages: 0,
    totalMovies: 0,
    searchText: '',
  },
  trailerVideo: null,
};
const moviesSlice = createSlice({
  name: 'movies',
  initialState: movieReducerInitialState,
  reducers: {
    addTrailerVideo: (state, actions) => {
      state.trailerVideo = actions.payload;
    },
    updateNowPlayingMovies: (state, actions) => {
      const { movieList, currentPage, totalPages, totalMovies, isPageUpdate } =
        actions.payload;
      if (isPageUpdate) {
        state.nowPlayingMovies = {
          ...state.nowPlayingMovies,
          currentPage,
        };
      } else {
        state.nowPlayingMovies = {
          movieList,
          currentPage,
          totalPages,
          totalMovies,
        };
      }
    },
    updatePopularMovies: (state, actions) => {
      const { movieList, currentPage, totalPages, totalMovies, isPageUpdate } =
        actions.payload;
      if (isPageUpdate) {
        state.popularMovies = {
          ...state.popularMovies,
          currentPage,
        };
      } else {
        state.popularMovies = {
          movieList,
          currentPage,
          totalPages,
          totalMovies,
        };
      }
    },
    updateTopRatedMovies: (state, actions) => {
      const { movieList, currentPage, totalPages, totalMovies, isPageUpdate } =
        actions.payload;
      if (isPageUpdate) {
        state.topRatedMovies = {
          ...state.topRatedMovies,
          currentPage,
        };
      } else {
        state.topRatedMovies = {
          movieList,
          currentPage,
          totalPages,
          totalMovies,
        };
      }
    },
    updateUpcomingMovies: (state, actions) => {
      const { movieList, currentPage, totalPages, totalMovies, isPageUpdate } =
        actions.payload;
      if (isPageUpdate) {
        state.upcomingMovies = {
          ...state.upcomingMovies,
          currentPage,
        };
      } else {
        state.upcomingMovies = {
          movieList,
          currentPage,
          totalPages,
          totalMovies,
        };
      }
    },
    updateSearchMovies: (state, actions) => {
      const {
        movieList,
        currentPage,
        totalPages,
        totalMovies,
        isPageUpdate,
        searchText,
      } = actions.payload;
      if (isPageUpdate) {
        state.searchMovies = {
          ...state.searchMovies,
          currentPage,
        };
      } else {
        state.searchMovies = {
          movieList,
          currentPage,
          totalPages,
          totalMovies,
          searchText,
        };
      }
    },
  },
});

export const {
  addTrailerVideo,
  updateNowPlayingMovies,
  updatePopularMovies,
  updateTopRatedMovies,
  updateUpcomingMovies,
  updateSearchMovies,
} = moviesSlice.actions;
export default moviesSlice.reducer;
